export const ApiBaseUrl = "https://wgcapi.mmocircles.com"; // Live API URL

export const apiUrls = {
  getAllGames: "/games",
  // auth: {
  //   login: "Auth/authenticate",
  //   validateTwoFACode: "Auth/ValidateTwoFACode",
  //   resendTwoFACode: "Auth/ResendTwoFACode",
  //   validateResetPasswordLink: "Auth/ValidateResetPasswordLink",
  //   resetPassword: "Auth/ResetPassword",
  //   forgotPassword: "Auth/ForgotPassword",

  // },
};
